import React from 'react'
import styles from "./styles.module.css";

const ToggleButton = ({ state, toggle }) => {
  return (
    <div className={`${styles.container} ${state ? styles.darkMode : styles.lightMode}`}
      onClick={() => toggle()}>
      <span className={styles.circle}></span>
    </div>
  )
};

export default ToggleButton;